<app-page-spinner [(show)]="loading"></app-page-spinner>

<ng-container *ngIf="!loading">

  <div class="esf-main-layout esf-main-layout--has-header">
    <main class="esf-main-content -has-transition">
      <div class="esf-container esf-container--full-width">
        <h3 i18n='Section title@@homeComponent.section.customerData'>Customer Data</h3>
        <div class="esf-function-tile-grid">
          <div class="esf-function-tile-grid__item">
            <a class="esf-function-tile" [routerLink]="searchLink">
              <svg class="esf-icon esf-icon--darkest" width="48" height="48">
                <use xlink:href="#esf-icon-user-search"></use>
              </svg>
              <h4 i18n='Subsection title@@homeComponent.subSection.search' class="esf-heading esf-heading--low-level">Search</h4>
            </a>
          </div>

          <div class="esf-function-tile-grid__item" *ngIf="(authenticatedUser.isAdminType) && !selectedClub.isDataFeedActive">
            <a class="esf-function-tile" [routerLink]="importsLink">
              <svg class="esf-icon esf-icon--darkest" width="48" height="48">
                <use xlink:href="#esf-icon-users-add"></use>
              </svg>
              <h4 i18n='Subsection title@@homeComponent.subSection.imports' class="esf-heading esf-heading--low-level">Imports</h4>
            </a>
          </div>

          <div class="esf-function-tile-grid__item">
            <a class="esf-function-tile" [routerLink]="remindersLink">
              <span [ngClass]="{'esf-badge': openReminders !== 0}" [attr.data-badge]="openReminders">
                <svg class="esf-icon esf-icon--darkest" width="48" height="48">
                  <use xlink:href="#esf-icon-bell-outline"></use>
                </svg>
              </span>
              <h4 i18n='Subsection title@@homeComponent.subSection.reminders' class="esf-heading esf-heading--low-level">Reminders</h4>
            </a>
          </div>

          <div class="esf-function-tile-grid__item" *ngIf="selectedClub.tixxCustomerMergeAllowed && (authenticatedUser.isAdminType || authenticatedUser.isTicketAgent)">
            <a class="esf-function-tile" [routerLink]="mergeLink">
              <svg class="esf-icon esf-icon--darkest" width="48" height="48">
                <use xlink:href="#esf-icon-people-two-48"></use>
              </svg>
              <h4 i18n='Subsection title@@homeComponent.subSection.mergeCustomers' class="esf-heading esf-heading--low-level">Merge Customers</h4>
            </a>
          </div>
        </div>

        <h3 i18n='Section title@@homeComponent.section.settings' *ngIf="authenticatedUser.isAdminType">Settings</h3>
        <div class="esf-function-tile-grid">
          <div class="esf-function-tile-grid__item" *ngIf="authenticatedUser.canSeeSettings">
            <a class="esf-function-tile" [routerLink]="clubSettingsLink">
              <svg class="esf-icon esf-icon--darkest" width="48" height="48">
                <use xlink:href="#esf-icon-club"></use>
              </svg>
              <h4 i18n='Subsection title@@homeComponent.subSection.club' class="esf-heading esf-heading--low-level">Club</h4>
            </a>
          </div>
          <div class="esf-function-tile-grid__item" *ngIf="authenticatedUser.canAddClubAttributes">
            <a class="esf-function-tile" [routerLink]="clubAttributesLink">
              <svg class="esf-icon esf-icon--darkest" width="48" height="48">
                <use xlink:href="#esf-icon-attributes"></use>
              </svg>
              <h4 i18n='Subsection title@@homeComponent.subSection.attributes' class="esf-heading esf-heading--low-level">Attributes</h4>
            </a>
          </div>
          <div class="esf-function-tile-grid__item" *ngIf="authenticatedUser.canListUsers">
            <a class="esf-function-tile" [routerLink]="clubUsersLink">
              <svg class="esf-icon esf-icon--darkest" width="48" height="48">
                <use xlink:href="#esf-icon-user-data"></use>
              </svg>
              <h4 i18n='Subsection title@@homeComponent.subSection.users' class="esf-heading esf-heading--low-level">Users</h4>
            </a>
          </div>
          <div class="esf-function-tile-grid__item" *ngIf="authenticatedUser.isAdminType && selectedClub.isLotteryActive">
            <a class="esf-function-tile" [routerLink]="lotteryLink">
              <svg class="esf-icon esf-icon--darkest" width="48" height="48">
                <use xlink:href="#esf-icon-clover-leaf-48"></use>
              </svg>
              <h4 i18n='Subsection title@@homeComponent.subSection.tixxSelect' class="esf-heading esf-heading--low-level">Tixx-Select</h4>
            </a>
          </div>
        </div>
      </div>
    </main>
  </div>

</ng-container>
